<ul>
    <a class="nav-item-mobile" routerLink="/home" (click)="close()" routerLinkActive="active" i18n>Home</a>
    <a class="nav-item-mobile" routerLink="/matching" (click)="goToMatching()" routerLinkActive="active" i18n>Matching</a>
    <a class="nav-item-mobile" routerLink="/profiles" (click)="close()" routerLinkActive="active" i18n>Profiles</a>
</ul>